import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
//import Home from './pages/Home/Home';
import About from './pages/About/About';
import News from './pages/News/News';
import Contact from './pages/Contact/Contact';
import CalendarPage from './pages/Calendar/CalendarPage';
import Gallery from './pages/Gallery/Gallery';


import Header from './components/Header/Header';
import Subheader from './components/Subheader/Subheader';
import Footer from './components/Footer/Footer';



function App() {
  return (
    <Router>
      <Header />
      <Subheader />
      <Routes>
        <Route path="/" element={<About />} />
        <Route path="/about" element={<About />} />
        <Route path='/news' element={<News />} />
        <Route path='/gallery' element={<Gallery />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/calendar' element={<CalendarPage />} />
        <Route path='/league' element={<CalendarPage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
